/** @description Типы флоу работы с различными типами баннеров */
export var EBannerSource = /*#__PURE__*/function (EBannerSource) {
  EBannerSource["Adfox"] = "adfox";
  EBannerSource["Internal"] = "internal";
  return EBannerSource;
}({});